module.exports = __webpack_public_path__ + "static/img/fuwu1.5fc938d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu1.png
// module id = VgWn
// module chunks = 1